<template>
  <div style="min-width: 1200px; min-height: 45vh;">
    <q-card style="min-height: 45vh;">
      <q-form ref="form">
        <div class="row q-pa-md">
          <div class="col-12">
            <div class="d-flex justify-content-between">
              <h4 class="mt-0 mb-3" style="font-size: 26px; font-weight: 300;">Update Retail Sales</h4>
              <span class="d-block">
                <q-btn @click="closeDialog" class="q-ml-auto" flat icon="close" round size="small"></q-btn>
              </span>
            </div>
          </div>
          <div class="col-4 q-pa-md pb-0" style="border-right: 1px solid lightgray">
            <div>
              <div class="mb-4">
                <q-select :options="customerArr"
                          :rules="[val=>val && typeof(val) === 'object' || 'Please select Customer']"
                          @filter="filterCustomer" class="searchBox w-100 p-2 mb-3" @input="onSelectCustomer"
                          @blur="onPopupHide" clearable label="Select Customer Company*" outlined style="width: 41.66%"
                          filled
                          use-input v-model="customer">
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">No results</q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:option="scope">
                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents" @click="onSelectCustomerOption(scope.opt)">
                      <q-item-section>
                        <q-item-label v-html="scope.opt.companyName"></q-item-label>
                        <q-item-label caption>{{ toLower(scope.opt.email) }}</q-item-label>
                        <q-item-label caption>{{ scope.opt.mobile }}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:selected-item="scope"> {{ scope.opt.companyName }}</template>
                </q-select>
              </div>
              <div class="my-4">
                <q-input class="searchBox p-2 my-3" label="Customer Name" v-model="customerName"></q-input>
              </div>
              <div class="my-4">
                <q-input :rules="[val => val && val.length && val.length === 10 || 'Invalid mobile']"
                         class="searchBox p-2 my-3" label="Customer Mobile" lazy-rules mask="##########"
                         v-model="customerMobile"></q-input>
              </div>
              <div class="my-4">
                <q-input :rules="[val => val&&val.length && emailPattern.test(val) || 'Invalid Email']"
                         class="searchBox p-2 my-3" label="Customer Email" lazy-rules type="email"
                         v-model="customerEmail"></q-input>
              </div>
              <div class="my-4">
                <q-input class="searchBox p-2 my-3" label="Customer Phone" v-model="customerPhone"></q-input>
              </div>
              <div class="my-4">
                <q-input class="searchBox p-2 my-3" label="Customer City" v-model="customerCity"></q-input>
              </div>
            </div>
          </div>
          <div v-if="groupTwoSelection.length" class="col-8 q-pa-md pb-0">
            <div class="pl-2 text-h6"> Product Details</div>
            <div class="row q-pa-md">
              <div class="col-4">
                <span class="bankLabel">SKU</span>
                <div>{{ groupTwoSelection[0].sku }}</div>
              </div>
              <div class="col-4">
                <span class="bankLabel">Serial</span>
                <div>{{ groupTwoSelection[0].serial }}</div>
              </div>
              <div class="col-4">
                <span class="bankLabel">Key</span>
                <div>{{ groupTwoSelection[0].productKey }}</div>
              </div>
            </div>
            <div class="row pl-3">
              <div class="col-3 mr-5">
                <q-input label="Activation Date*" class="py-2 searchBox" filled
                         v-model="groupTwoSelection[0].activationDate"
                         mask="##-##-####" :rules="[val=>val && val.length>0 || 'Please select Activation date',
                                                                  val => val.length && datePattern.test(val) || 'Invalid Date']">
                  <template v-slot:prepend>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy transition-show="scale" transition-hide="scale" :ref="'qDateProxy'">
                        <q-date v-model="groupTwoSelection[0].activationDate" mask="DD-MM-YYYY"
                                @input="$refs['qDateProxy'].hide()"></q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
              <div class="col-3">
                <q-input label="Expiry Date*" class="py-2 searchBox" readonly filled :value="groupTwoSelection[0].activationDate ? moment(groupTwoSelection[0].activationDate, 'DD-MM-YYYY').
                  add(groupTwoSelection[0].Product.validity ? groupTwoSelection[0].Product.validity : 365, 'days').
                  format('DD-MM-YYYY') : '-'"></q-input>
              </div>
            </div>
          </div>
          <div class="col-11"></div>
          <div class="col-1">
            <q-btn class="pd-btn " @click="onUpdateOrder">UPDATE</q-btn>
          </div>
        </div>
      </q-form>
    </q-card>
  </div>
</template>

<script>
import moment from 'moment'
import { GET_RETAIL_ORDERITEMS } from '@/graphql/queries/Orders'
import { GET_CUSTOMERS } from '@/graphql/queries/Customers'
import { INSERT_CUSTOMER, UPDATE_CUSTOMER } from '@/graphql/mutations/customer'
import { UPDATE_RETAIL_ORDER, UPDATE_RETAIL_ORDERITEMS } from '@/graphql/mutations/OrderItems'

export default {
  name: 'UpdateRetailSalesFortinet',
  props: ['orgId'],
  apollo: {
    customerArr: {
      query: GET_CUSTOMERS, skip () {return !this.orgId}, fetchPolicy: 'network-only',
      variables () {return { orgId: this.orgId }},
      result ({ data, loading }) {
        if (!loading) { this.temp_customerArr = JSON.parse(JSON.stringify(data.customerArr)) }
      },
    },
  },
  data: function () {
    return {
      moment: moment, user: JSON.parse(localStorage.getItem('user')),
      emailPattern: new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
      datePattern: new RegExp(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/),
      customerArr: [], temp_customerArr: [],
      customer: '', customerMobile: '', customerEmail: '', customerName: '', customerPhone: '', customerCity: '',
      tempValue: null,
      groupTwoSelection: [],
      orderId: null,
      updateLoader: false,
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeUpdateRSDialog', false)
    },
    assignValues (order) {
      this.orderId = order.id
      this.getOrderItems(order.id)
      this.customer = order.ToCustomer
      this.customerMobile = order.ToCustomer.mobile
      this.customerEmail = order.ToCustomer.email
      this.customerCity = order.ToCustomer.city
      this.customerPhone = order.ToCustomer.phone
      this.customerName = order.ToCustomer.name
    },
    async getOrderItems (orderId) {
      let response = await this.$apollo.query({
        query: GET_RETAIL_ORDERITEMS,
        fetchPolicy: 'network-only',
        variables: { orderId: orderId },
      })
      if (response.data) {
        let tempArr = []
        response.data.OrderItems.forEach((curnt) => {
          let obj = {
            orderItemId: curnt.id,
            serial: curnt.ProductInventory.serial,
            sku: curnt.ProductInventory.sku,
            activationDate: curnt.meta.activationDate,
            expiryDate: curnt.meta.expiryDate,
            Product: curnt.Product,
            productKey: curnt.meta.productKey,
            remark: curnt.meta.remark,
          }
          tempArr.push(obj)
        })
        this.groupTwoSelection = JSON.parse(JSON.stringify(tempArr))
      }
    },
    onSelectCustomer (val) {
      this.tempValue = null
      if (val) {
        this.customerMobile = val.mobile
        this.customerEmail = val.email
        this.customerPhone = val.phone
        this.customerCity = val.city
        this.customerName = val.name
      } else {
        this.customerPhone = ''
        this.customerCity = ''
        this.customerName = ''
        this.customerMobile = ''
        this.customerEmail = ''
        this.customer = ''
      }
    },
    onSelectCustomerOption (row) {
      this.customer = {
        id: row.id, name: row.name, mobile: row.mobile, email: row.email, phone: row.phone,
        city: row.city, companyName: row.companyName,
      }
      this.customerMobile = row.mobile
      this.customerEmail = row.email
      this.customerName = row.name
      this.customerCity = row.city
      this.customerPhone = row.phone
    },
    onPopupHide () {
      if (this.tempValue) {
        this.customerArr.push({ companyName: this.tempValue })
        this.customer = { companyName: this.tempValue }
      }
    },
    filterCustomer (val, update, abort) {
      if (val === '') {
        update(() => {
          this.customerArr = JSON.parse(JSON.stringify(this.temp_customerArr))
        })
        return
      }
      update(() => {
        this.tempValue = val
        this.customerArr = this.temp_customerArr.filter(function (el) {
          return (el.name?.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              el.email?.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              el.mobile?.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              el.phone?.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              el.companyName?.toLowerCase().indexOf(val.toLowerCase()) > -1
          )
        })
      })
    },
    onUpdateOrder () {
      let self = this
      this.$refs['form'].validate().then(success => {
        if (success && self.customer.id) {
          self.confirm(self.updateCustomer, self.customer.id)
        } else if (success) {
          self.confirm(self.insertCustomer)
        }
      })
    },
    confirm (callback, customerId) {
      let self = this
      this.$q.dialog({
        title: 'Confirm', message: 'Are you sure?', cancel: true, persistent: false,
      }).onOk(() => {
        self.updateLoader = true
        callback(customerId)
      }).onCancel(() => {})
    },
    async updateOrder(customerId){
      let response = await this.$apollo.mutate({
        mutation: UPDATE_RETAIL_ORDER,
        variables: {
          orderId: this.orderId,
          obj: {
            to: customerId,
            updatedOn: moment(),
            lastUpdatedBy: this.user.id,
          }
        },
      })
      if (response.data) {
        this.updateOrderItems(customerId)
      }
    },
    updateOrderItems (customerId) {
      let self = this
      let counter = this.groupTwoSelection.length
      for (var i = 0; i < this.groupTwoSelection.length; i++) {
        let inv = this.groupTwoSelection[i]
        this.$apollo.mutate({
          mutation: UPDATE_RETAIL_ORDERITEMS,
          variables: {
            orderItemId: inv.orderItemId,
            obj: {
              to: customerId,
              meta:
                  {
                    activationDate: inv.activationDate, productKey: inv.productKey, remark: inv.remark,
                    expiryDate: moment(inv.activationDate, 'DD-MM-YYYY').
                        add(inv.Product.validity ? inv.Product.validity : 365, 'days').
                        format('DD-MM-YYYY'),
                  },
            },
          },
        }).then(function (response) {
          counter--
          if (counter === 0) {
            self.updateLoader = false
            self.groupTwoSelection = []
            self.$q.notify('Retail Sales Order Updated Successfully')
            self.$emit('closeUpdateRSDialog', false)
          }
        })
      }
    },
    async insertCustomer () {
      let customerRequest = {
        id: this.generateUUID(),
        name: this.customerName,
        mobile: this.customerMobile,
        email: this.customerEmail,
        phone: this.customerPhone,
        city: this.customerCity,
        companyName: this.customer.companyName,
        orgId: this.orgId,
      }
      let response = await this.$apollo.mutate({
        mutation: INSERT_CUSTOMER,
        variables: customerRequest,
      })
      if (response.data) {
        this.updateOrder(customerRequest.id)
      }
    },
    async updateCustomer (customerId) {
      let customerRequest = {
        id: customerId, name: this.customerName,
        mobile: this.customerMobile, email: this.customerEmail,
        phone: this.customerPhone, city: this.customerCity,
        companyName: this.customer.companyName, orgId: this.orgId,
      }
      let response = await this.$apollo.mutate({
        mutation: UPDATE_CUSTOMER,
        variables: customerRequest,
      })
      if (response.data) {
        this.updateOrder(customerId)
      }
    },
    generateUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    forceUpdateTable (name) {
      this.groupTwoSelection = JSON.parse(JSON.stringify(this.groupTwoSelection))
      this.$refs[name].hide()
    },
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

/deep/ .q-table__middle {
  border: 1px solid #d0d0d087;
}

</style>
